import { defineMessages } from 'react-intl';

const messages = defineMessages({
  ShowMore: {
    defaultMessage: 'Show More',
    description: 'Button to show more works in the feed.'
  },
  ErrorMessage: {
    defaultMessage: "Oops. We can't fetch any results for you right now."
  },
  artistAttribution: {
    defaultMessage: 'by {artistName}',
    description: 'The artist who created this work.'
  }
});

export default messages;
